<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        scrollable
        width="400"
    >
      <v-card>

        <v-card-title>
          Filtrer par
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-4">

          <v-text-field class="mb-3"
                        type="date"
                        v-model="filter.startDate"
                        clearable
                        dense
                        label="Date début"
                        outlined
                        prepend-inner-icon="mdi-calendar"
                        hint="Sélectionnez la date de début du filtre"
                        persistent-hint
          ></v-text-field>

          <v-text-field
              type="date"
              v-model="filter.endDate"
              clearable
              dense
              label="Date fin"
              outlined
              prepend-inner-icon="mdi-calendar"
              hint="Optionnel — laissez vide pour filtrer à partir de la date début"
              persistent-hint
          ></v-text-field>

        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-btn block
                 :disabled="!filter.startDate"
                 color="primary"
                 depressed type="submit"
                 @click="handleFilter">
            <v-icon left>mdi-magnify</v-icon>
            Rechercher
          </v-btn>
        </v-card-actions>

      </v-card>


    </v-dialog>

  </div>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      filter: {},
    }
  },
  methods: {
    open() {
      this.filter = {
        startDate: null,
        endDate: null,
      }
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    handleFilter() {
      this.$emit('filter', this.filter)
      this.close()
    },
  },
}
</script>

